import { useContext, useState, useEffect } from "react";
import {
  notificationContextTypes,
  regulationContextTypes,
  typeFormDto,
  iTypeFormCategories,
} from "../../utils/typeDefs";
import { apiUrls } from "../../utils/apiUrls";
import FormRegTable from "../../Components/formRegTable/formRegTable.component";
import FormRegFunctionality from "../../Components/fromRegFuntionality/fromRegFunctionality";
import { RegulationContext } from "../../core/context/regulationContextProvider";
import ReusableModal from "../../Components/generic/modal/reusableModal.component";
import RegulationsModal from "../../Components/generic/modal/regulationsModal.component";
import { postData, getData } from "../../utils/reusables";
import { NotificationContext } from "../../core/context/notificationContextProvider";

type regulationProps = {
  title: string;
};

const Regulations = ({ title }: regulationProps) => {
  const {
    regulationPageData,
    setRegulationPageData,
    sortedCountryData,
    currentCountryId,
    setCurrentCountryId,
  } = useContext(RegulationContext) as regulationContextTypes;

  const { triggerNotification } = useContext(
    NotificationContext,
  ) as notificationContextTypes;
  const addButton = "Add Regulations";

  // Modal
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [modalType, setModalType] = useState<string | null>(null);

  const handleOpenModal = () => {
    setUrlId(0); // Reset urlId for Add operation
    setModalType("regulation");
    setOpenModal(true);
  };

  const handleDelete = () => {
    setModalType(null);
    setModalType("delete");
  };

  const handleEdit = () => {
    setModalType(null);
    setModalType("edit");
  };

  const handleCloseModal = () => {
    setModalType(null);
    setOpenModal(false);
  };

  // Search
  const [search, setSearch] = useState("");
  const [searchData, setSearchData] = useState(regulationPageData);

  const filter = (item: React.FormEvent<HTMLInputElement>) => {
    const keyword = item.currentTarget.value;

    if (keyword === "") {
      setSearchData(regulationPageData);
    } else if (regulationPageData) {
      const result = regulationPageData.filter((val: typeFormDto) => {
        return val.title.toLowerCase().includes(keyword.toLowerCase());
      });
      setSearchData(result);
    }

    setSearch(keyword);
  };

  // Apply reviews
  const [reviewIds, setReviewIds] = useState<number[] | []>([]);
  const [reviewDate, setReviewDate] = useState<string | null>(null);

  const applyReviewData = async () => {
    const dataToPost = {
      countryId: currentCountryId,
      ids: reviewIds,
      lastReviewDate: reviewDate,
    };

    if (reviewDate === null) {
      triggerNotification(false, "Review date not found");
    } else {
      setRegulationPageData(null);
      postData(apiUrls.regulation.applyReview, dataToPost).then((result) => {
        if (result.data.succeeded || result.status === 200) {
          setRegulationPageData(result.data.data);
          triggerNotification(true, result.data.message);
        } else {
          setRegulationPageData(regulationPageData);
          triggerNotification(false, "Data update failed");
        }
        setReviewIds([]);
        setReviewDate(null);
      });
    }
  };

  // Initial Table data
  useEffect(() => {
    setSearchData(regulationPageData);
  }, [regulationPageData]);

  // Select and deselect checkbox
  const handleCheckBoxAll = (value: boolean) => {
    const newData: (typeFormDto[] & { checked?: boolean }) | null =
      regulationPageData
        ? regulationPageData.map((item: typeFormDto) =>
            Object.assign(item, { checked: value }),
          )
        : null;

    setSearchData(null);
    setRegulationPageData(newData);

    if (value && newData) {
      setReviewIds(newData.map((data: typeFormDto) => data.id));
    } else setReviewIds([]);
  };

  // Regulation data and functions
  const [urlId, setUrlId] = useState<number>(0);

  // Regulation categories
  const [regulationCategoryData, setRegulationCategoryData] = useState<
    iTypeFormCategories[] | []
  >([]);

  useEffect(() => {
    getData(apiUrls.regulation.getCategories).then((result) => {
      if (result.status === 200) {
        setRegulationCategoryData(result.data);
      }
    });
  }, []);

  return (
    <section className="d-flex flex-column">
      <div className="content-box-title">
        <h1 className="page-title pb-3">{title}</h1>
        <div>
          <FormRegFunctionality
            data={regulationPageData}
            defaultId={null}
            setData={setRegulationPageData}
            addButton={addButton}
            currentCountryId={currentCountryId}
            setCurrentCountryId={setCurrentCountryId}
            sortedCountryData={sortedCountryData}
            reviewIds={reviewIds}
            search={search}
            searchData={searchData}
            setReviewDate={setReviewDate}
            handleOpenModal={handleOpenModal}
            handleCheckBoxAll={handleCheckBoxAll}
            applyReviewData={applyReviewData}
            filter={filter}
          />
        </div>

        <div className="tableHeight my-2 shadow rounded">
          <FormRegTable
            data={searchData}
            url={`Regulation`}
            urlId={urlId}
            setUrlId={setUrlId}
            currentCountryId={currentCountryId}
            setSearchData={setRegulationPageData}
            reviewIds={reviewIds}
            setReviewIds={setReviewIds}
            modalType={modalType}
            setModalType={setModalType}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleCheckBoxAll={handleCheckBoxAll}
            formCategoryData={regulationCategoryData}
          />
        </div>
      </div>
      <ReusableModal
        modalType={modalType}
        modalTitle="Add Regulations"
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        children={
          <RegulationsModal
            id={urlId}
            countryId={currentCountryId}
            modalType={modalType}
            handleCloseModal={handleCloseModal}
            setData={setSearchData}
            currentRowData={null}
            loadData={modalType === "edit"}
            regulationCategoryData={regulationCategoryData}
          />
        }
      />
    </section>
  );
};

export default Regulations;
